import type {
  AuthRepository,
  CreatePsiInput,
  SessionClient,
  UserPsi,
  UserRepository,
} from "@phurshell/psiapp-frontend-core/domain";

export class CreatePsi {
  constructor(
    private readonly authRepo: AuthRepository,
    private readonly sessionClient: SessionClient,
    private readonly userRepo: UserRepository,
  ) {}

  async execute(params: CreatePsiInput): Promise<UserPsi> {
    const data = await this.userRepo.createPsi(params);

    const { user, access_token } = await this.authRepo.login({
      email: params.email,
      password: params.password,
    });

    this.sessionClient.saveAuthToken(access_token);

    const userData = await this.userRepo.getUserById(user.id);
    this.sessionClient.saveSession(userData);

    return { ...userData, account_link: data.account_link };
  }
}
